exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"fontStack": "'Roboto', sans-serif",
	"defaultFontSize": "14px",
	"white": "#fff",
	"offwhite": "#ddd",
	"lighterGrey": "#999",
	"midGrey": "#666",
	"lightGrey": "#333",
	"grey": "#282828",
	"darkGrey": "#202020",
	"darkerGrey": "#181818",
	"darkestGrey": "#121212",
	"red": "#a94442",
	"darkRed": "#843534",
	"darkYellow": "#A99A42",
	"green": "#3E7640",
	"darkGreen": "#2b542c",
	"trdRed": "#d80500",
	"boxShadow": "2px 2px 5px darkestGrey",
	"buttonBorder": "1px solid darkerGrey",
	"buttonHoverBorder": "1px solid grey",
	"defaultBorderRadius": "0px",
	"transition": ".5s"
};